export const constantVar = {
  syncfusionKey:
    'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXpfdnRXR2ZcVUVwVkdWYE4=',
};
